<style>
.eso-tags ul{
  margin: 0;
  padding: 0;
}
.eso-tags .tag{
  font-size: 13px;
  position: relative;
  cursor: pointer;
  list-style-type: none;
  float: left;
  background-color: #20A0FF;
  margin-right: 15px;
  color:white;
  padding: 8px 8px;
  border-radius: 4px;
  margin-top: 15px;
}
.eso-tags .tag:hover .close {
  display: block;
}
.eso-tags .tag .close{
  display: none;
  width: 13px;
  height: 13px;
  background-color: white;
  color: #FF4949;
  font-size: 12px;
  position: absolute;
  right: -5px;
  top:-6px;
  background: url('../../assets/common/delete.svg')
}
</style>

<template>
  <div class="eso-tags">
    <ul class="clearfix">
      <li class="tag" v-for="(item, index) in items" @click="select(index)">
        <span v-show="labelname">{{item[labelname]}}</span>
        <span v-show="!labelname">{{item}}</span>
        <i class="close"></i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tag',
  props: {
    value: [Array],
    label: [String]
  },
  watch: {
    'value' (val, oldValue) {
      this.items = val
      // console.log(val)
    }
  },
  mounted () {
    // console.log(this.items)
  },
  data () {
    return {
      items: this.value,
      labelname: this.label
    }
  },
  methods: {
    select (index) {
      this.$emit('click', index)
      // console.log(val)
      // console.log(index)
    }
  }
}
</script>



// WEBPACK FOOTER //
// tag.vue?bd2c9ed2